"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformativeComponent = void 0;
var utils_1 = require("../../../utils");
var React = require("react");
var answers_lib_1 = require("@wix/answers-lib");
exports.InformativeComponent = function (props) {
    var informativeTitle = props.value.title;
    var informativeColor = props.value.color;
    return (React.createElement("div", { className: answers_lib_1.classNames('component', 'informative-component', props.direction), "data-component-type": 'informative' },
        React.createElement("div", { className: 'informative-content', "data-color": informativeColor },
            React.createElement("span", { className: 'informative-title' },
                React.createElement("strong", null, informativeTitle)),
            React.createElement(utils_1.RenderHtml, { html: props.value.html, className: 'rendered-html' }))));
};
//# sourceMappingURL=informative-component.comp.js.map